import classNames from 'classnames'
import './styles.scss'

/**
 * CircleLoader
 * @param {size} - `small` or default
 * @param {color} - `light` or default
 * @param {className} - additional class names
 */
export function CircleLoader({ size, color, className }) {
    const classList = classNames('circle-loader', {
        [`circle-loader--${size}`]: size,
        [`circle-loader--${color}`]: color,
        [className]: className,
    })

    return (
        <div className={classList}>
            {[...Array(10).keys()].map(index => (
                <div key={index} className="circle-loader__dot"></div>
            ))}
        </div>
    )
}

CircleLoader.propTypes = {
    size: PropTypes.oneOf(['small', 'medium']),
    color: PropTypes.oneOf(['light', 'primary']),
}

export default CircleLoader
